import Authorities from '@/types/Authority';
import { hasPermissions } from '@/utils/functions/hasPermissions';
import { Button } from 'antd';
import BankSlipConsultFileModal from './BankSlipConsultFileModal';
import { useDisclosure } from '@/hooks';
import {
  RemittanceReturnProtocolRequest,
  RemittanceReturnProtocolResponse,
} from '@/core/domain/financial/Boletos/Boletos.types';
import { useBankSlipFormContext } from '@/pages/FinancialPages/BankSlipPage';
import { useRemitanceReturnProtocol } from '@/core/domain/financial/Boletos/Boletos.hooks';
import ConsultFileResponseModal from './ConsultFileResponseModal';
import { useState } from 'react';

export default function ConsultFileButton() {
  const { queryParams } = useBankSlipFormContext();

  const [consultFileModalOpened, consultFileModalActions] = useDisclosure();
  const [consultFileResponseModalOpened, consultFileMResponseodalActions] =
    useDisclosure();
  const [consultFileResponse, setConsultFileResponse] =
    useState<RemittanceReturnProtocolResponse>();

  const consultFileMutation = useRemitanceReturnProtocol();

  const handleVerifySituation = async (
    values: RemittanceReturnProtocolRequest,
  ) => {
    if (values) {
      const response = await consultFileMutation.mutateAsync({
        ...values,
      });

      if (response) {
        setConsultFileResponse(response);

        consultFileMResponseodalActions.open();
      }
    }
  };

  return (
    <>
      <Button
        disabled={
          !hasPermissions([Authorities.FINANCIAL_BILL_READ_RETURN_FILE])
        }
        block
        type="primary"
        onClick={consultFileModalActions.open}
      >
        Consultar arquivo de processamento
      </Button>

      <BankSlipConsultFileModal
        loading={consultFileMutation.isLoading}
        open={consultFileModalOpened}
        onCancel={consultFileModalActions.close}
        onCallback={handleVerifySituation}
        companyId={queryParams.companyId}
      />

      <ConsultFileResponseModal
        onCancel={consultFileMResponseodalActions.close}
        open={consultFileResponseModalOpened}
        data={consultFileResponse}
      />
    </>
  );
}
